export const config = (accessToken: string | null, signal?: AbortSignal) => ({
  headers: { Authorization: injectBearer(accessToken) },
  signal,
});

export const gatewayConfig = (
  accessToken: string | null,
  clinicId: string,
  signal?: AbortSignal
) => ({
  headers: {
    Authorization: injectBearer(accessToken),
    "X-Clinic-Id": clinicId,
  },
  signal,
});

export const injectBearer = (accessToken: string | null) =>
  `Bearer ${accessToken}`;

export const webServiceUrl = process.env.REACT_APP_WEB_SERVICE ?? "";

export const examServiceUrl = process.env.REACT_APP_EXAM_SERVICE ?? "";

export const apiGatewayUrl = process.env.REACT_APP_API_GATEWAY ?? "";
